var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgQuotation = function SvgQuotation(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0345 23.8106L22.7199 28.1254L18.7425 24.1477L22.9929 19.8973C23.7336 19.1567 24.375 17.9347 24.375 16.8677V14.9927L16.875 14.9927V1.86768H30V16.8677C30 19.6436 28.8645 21.9808 27.0345 23.8106Z",
    fill: "#5FB4BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1596 23.8106L5.84496 28.1254L1.86748 24.1478L6.11803 19.8973C6.85854 19.1567 7.5 17.9348 7.5 16.8677V14.9927L0 14.9927L1.14742e-06 1.86768H13.125V16.8677C13.125 19.6436 11.9895 21.9808 10.1596 23.8106Z",
    fill: "#5FB4BE"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuotation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quotation.ef183a28.svg";
export { ForwardRef as ReactComponent };